import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface, Validator } from 'class-validator';
import { CustomCommonValidator } from './customCommonValidator';
import * as moment from 'moment';

@ValidatorConstraint()
export class PersonValidation extends CustomCommonValidator implements ValidatorConstraintInterface {

    validate(dynamicProperties: any, validationArguments: ValidationArguments) {
        let properties: string[] = Object.getOwnPropertyNames(dynamicProperties);
        let result: boolean = true;
        const validator = new Validator();
		this.message = '';

        if (properties.find(p => p == 'person') != null) {
            let person: PersonItem = dynamicProperties['person'] as PersonItem;
            if (!validator.isNotEmpty(person.salutation)) {
                this.message = 'Satulation is required <br />';
                result = false;
            }
            if (!validator.isNotEmpty(person.firstName)) {
                this.message = this.message.concat('FirstName is required <br />');
                result = false;
            }
            if (person.firstName != null && !validator.maxLength(person.firstName, 128)) {
                this.message = this.message.concat('FirstName is to  long <br />');
                result = false;
            }
            if (!validator.isNotEmpty(person.lastName)) {
                this.message = this.message.concat('LastName is required <br />');
                result = false;
            }
            if (person.lastName != null && !validator.maxLength(person.lastName, 256)) {
                this.message = this.message.concat('LastName is to  long <br />');
                result = false;
            }
            if (!validator.isNotEmpty(person.gender)) {
                this.message = this.message.concat('Gender is required <br />');
                result = false;
            }
            if (person.middleName != null &&!validator.maxLength(person.middleName, 128)) {
                this.message = this.message.concat('MiddleName is to  long <br />');
                result = false;
            }
            if (person.height != null && !validator.isNumberString(person.height.toString())) {
                this.message = this.message.concat('Height must be a number <br />');
                result = false;
			}
			if (person.birthDate != null) {
				let age = moment.utc().diff(person.birthDate, 'year');
				if (age < 18) {
					this.message = this.message.concat('Clients must be over 18 years old');
					result = false;
				}
			
			}
        }
        return result;
	}

    defaultMessage(args: ValidationArguments) { // here you can provide default error message if validation failed
        return this.message;
    }
}



// WEBPACK FOOTER //
// ./src/core/customValidator/personValidator.ts